import React, { useContext } from "react";
import { AppContext } from "../../../Commons/Scripts/Contexts";

// Mismos recursos que Default.aspx / Default.aspx.cs; no es el logo de la compañía.
export const MarcaConfiguracionInicial = () => {
  const app = useContext(AppContext);
  if (!app?.configuration?.Vendor) return <span className="ci-product-logo" aria-hidden="true" />;
  const esGestionNegocios = app?.configuration?.Vendor === "claro";
  return <img className="ci-product-logo"
    src={esGestionNegocios ? "/img/Logo-GN-ERP.png" : "/img/Logo-CITRUS-ERP.png"}
    alt={esGestionNegocios ? "Gestión Negocios ERP" : "Citrus ERP"} />;
};
